import axiosInstance from '@/store/axios'
import { rejectErrorApi, rejectError } from '@/store/helper'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    programs ({ commit }, params) {
      return axiosInstance.get('/api/v1/programs', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    programs2 ({ commit }, params) {
      return axiosInstance.get('/api/v1/programs2', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    getProgramById ({ commit, state }, data) {
      const params = {}
      if (data.expand) {
        params.$expand = data.expand
      }
      // eslint-disable-next-line consistent-return
      return axiosInstance.get(`/api/v1/programs/${data.id}`, { params })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    getProgram2ById ({ commit, state }, params) {
      // eslint-disable-next-line consistent-return
      return axiosInstance.get(`/api/v1/programs2/${params.id}`, { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    programCount ({ commit }, data) {
      const params = {}
      if (data.types) {
        params['type[in]'] = data.types
      }
      return axiosInstance.get('/api/v1/programs/$count', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    clearSchedule ({ commit }, params) {
      return axiosInstance.post('/api/v1/programs/commands/clear-schedule', {}, {
        params,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
  },
}
